<template>
  <v-card class="p-4">
    <v-card-title v-if="title" class="justify-center mb-4"><span class="title-modal">{{ title }}</span></v-card-title>
    <v-alert type="error" color="#e72c1f" v-if="errorMsg !== null">{{ errorMsg }}</v-alert>
    <v-alert type="error" color="#e72c1f" v-if="error !== null">{{ error }}</v-alert>
    <div class="my-12 p-4" v-if="!isWaitingConfirmationCode">
      <v-text-field
          v-mask="['(##) ####-####', '(##) #####-####']"
          v-model="phone"
          :rules="rules.phone"
          label="Celular"
          outlined
      ></v-text-field>
      <div class="d-flex justify-center">
        <v-btn
            depressed
            @click.prevent="askForCode"
            class="btn-confirm p-2"
        >
          Enviar Código
        </v-btn>
      </div>
    </div>
    <div class="my-12 p-4" v-else>
      <vue-o-t-p-input
          :digit-count="4"
          @handle-code="handleCode"
      ></vue-o-t-p-input>

      <v-row class="mt-2">
        <v-btn
            text
            :disabled="isWaitingToResend"
            class="btn btn-block text-h6 mt-0 mb-0"
            @click.prevent="askForCode"
        >
          Reenviar {{ this.time > 0 ? this.time : '' }}
        </v-btn>
        <v-btn @click.prevent="handleCode"
               class="btn-confirm btn-block mt-4 mb-1">
          Confirmar
        </v-btn>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";
import VueOTPInput from './OTP';

export default {
  name: "VerifyPhoneForm",
  props: ['title', 'errorMsg'],
  components: {
    VueOTPInput
  },
  data: function () {
    return {
      phone: '',
      verificationCode: '',
      time: 60,
      interval: undefined,
      isWaitingConfirmationCode: false,
      isWaitingToResend: false,
      error: null,
      rules: {
        phone: [
          value => (value && value.length > 0 || (this.phone && this.phone.length > 0)) || 'O campo celular é obrigatório',
        ],
      }
    }
  },
  mounted() {
    axios.get('/api/users/driver/me').then(({data}) => {
      this.phone = this.phoneToPattern(data.user.phone);
    });
  },
  methods: {
    decrementTime() {
      this.time = parseInt(this.time) - 1;
      if (this.time <= 0) {
        clearInterval(this.interval);
        this.isWaitingToResend = false;
      }
    },
    askForCode: function () {
      if (this.phone.length > 7) {
        axios.post('/api/signup/resubmit/phone', {
          phone: this.phone,
        })
            .then(res => {
              if (res.status === 200) {
                this.isWaitingConfirmationCode = true;

                this.isWaitingToResend = true;
                this.interval = setInterval(this.decrementTime, 1000);
              }
            })
            .catch((error) => this.error = error.response.data.message)
      }
    },
    handleCode: function (code = this.verificationCode) {
      this.verificationCode = code;
      axios
          .post('/api/signup/activate/phone/' + code)
          .then(() => {
            this.error = '';
            this.$emit('continue-action');
          })
          .catch((error) => this.error = error.response.data.message);
    },
    phoneToPattern: function (value) {
      if (value) {
        if (value.length === 11) {
          value = "(" + value.substring(0, 2) + ") " + value.substring(2, 7) + "-" + value.substring(7, 11);
        }
        return value;
      }
    },
  }
}
</script>

<style scoped>

</style>
